import * as PropTypes from 'prop-types';
import * as React from 'react';
import { without, includes, union } from 'lodash';

class CheckboxFilterList extends React.Component {
  static get defaultProps() {
    return {
      getValue: facet => facet.value,
      getName: facet => facet.value,
    };
  }

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const newSelected = this.toggleValue(e.target.value);
    this.props.onChange(newSelected);
  }

  toggleValue(val) {
    if (this.isSelected(val)) {
      return without(this.props.selected, val);
    }

    return union(this.props.selected, [val]);
  }

  isSelected(value) {
    return includes(this.props.selected, value);
  }

  renderCount(facet) {
    return (
      <span className="facet__option__count">
        ({facet.count})
      </span>
    );
  }

  renderLabel(facet) {
    return (
      <span className="facet__label__text">
        {this.props.getName(facet)} {this.renderCount(facet)}
      </span>
    );
  }

  renderCheckboxInput(id, value) {
    return (
      <input
        type="checkbox"
        onChange={this.handleChange}
        value={value}
        id={id}
        checked={this.isSelected(value)}
        className="d-inline-block"
      />
    );
  }

  renderCheckbox(facet) {
    const id = `${this.props.name}-${this.props.getValue(facet)}`.replace(/ /g, '_');
    const value = this.props.getValue(facet);

    return (
      <li
        key={id}
        data-filter={id}
        className="facet__option facet__option--checkbox"
      >
        {this.renderCheckboxInput(id, value)}
        <label htmlFor={id} className="facet__label">
          {this.renderLabel(facet)}
        </label>
      </li>
    );
  }

  render() {
    if (!this.props.facets) { return false; }
    return (
      <ul className="facet__options">
        {this.props.facets.map(facet => this.renderCheckbox(facet))}
      </ul>
    );
  }
}

CheckboxFilterList.propTypes = {
  name: PropTypes.string.isRequired,
  facets: PropTypes.array.isRequired, // array of {value:, count:}
  selected: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  getValue: PropTypes.func,
  getName: PropTypes.func,
};

export default CheckboxFilterList;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/checkbox_filter_list.jsx